import { connect } from 'react-redux';
import UtilityList from './UtilityList';

import { setUtilityProvider } from '../../../common/utility/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isOpen: state.clientInfoUI.isOpen,
    projectState: state.projectaddress.projectState,
    provider: state.utility.provider,
    setUtilityProvider,
});

const combinedActions = {
    setUtilityProvider,
};

export default connect(mapStateToProps, combinedActions)(UtilityList);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/UtilityList/index.js